import { useEffect } from 'react';
function useScrollToTop(deps = []) {
  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}

export default useScrollToTop;
